import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { X, Cookie } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 2000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-6 left-6 right-6 z-50 animate-in slide-in-from-bottom duration-500">
      <Card className="max-w-2xl mx-auto shadow-2xl border-2 border-orange-200 bg-white/95 backdrop-blur-md">
        <CardHeader className="pb-3">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-100 to-red-100 rounded-lg flex items-center justify-center">
                <Cookie className="text-orange-500" size={20} />
              </div>
              <CardTitle className="text-xl">Cookie-Einstellungen</CardTitle>
            </div>
            <button 
              onClick={handleDecline}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Schließen"
            >
              <X size={20} />
            </button>
          </div>
        </CardHeader>
        <CardContent className="pb-3">
          <CardDescription className="text-gray-700 text-sm leading-relaxed">
            Wir verwenden Cookies, um Ihnen die beste Erfahrung auf unserer Website zu bieten. 
            Diese Cookies helfen uns, die Website-Funktionalität zu verbessern und Ihre Präferenzen zu speichern.
            Ihre Daten bleiben geschützt und werden ausschließlich auf Servern in Deutschland gespeichert.
            <br />
            <a href="/datenschutz" className="text-orange-500 hover:text-orange-600 font-medium underline mt-2 inline-block">
              Mehr über unsere Datenschutzrichtlinien erfahren
            </a>
          </CardDescription>
        </CardContent>
        <CardFooter className="flex flex-col sm:flex-row gap-3 pt-3">
          <Button
            onClick={handleAccept}
            className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white shadow-md hover:shadow-lg transition-all flex-1"
          >
            Alle Cookies akzeptieren
          </Button>
          <Button
            onClick={handleDecline}
            variant="outline"
            className="border-gray-300 hover:bg-gray-50 transition-colors flex-1"
          >
            Nur notwendige Cookies
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default CookieBanner;